'use strict';
import isNumber from 'lodash/isNumber';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/last';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/withLatestFrom';
import {createEventHandler} from 'recompose';
import * as T from 'prop-types';
import fuse from '../../../_libs/redux-fusion';
import {gpsSupported} from '../../../core-utilities-implementation/device-services/DeviceServicesCordova';
import {getCollection, getId} from '../../../core-utilities/domain/ReduxUtils';
import {pauseTimer, queueIdGenerator, startTimer, stopTimer} from '../../actions';
import {findByTarget} from '../../reducers/activeTimersReducers';
import {getActiveTimers} from '../../reducers';
import {renderLocationText} from '../../utils';
import {TaskInfoTimerView} from './TaskInfoTimerView';
import {canStartTimer} from '../../../tasks/domain/utils';


const StreamedComponent = (state$, dispatch) => (props$) => {
  const {
    handler: onClickStart,
    stream: startTimer$,
  } = createEventHandler();

  const {
    handler: onClickPause,
    stream: pause$,
  } = createEventHandler();

  const {
    handler: onClickStop,
    stream: stop$,
  } = createEventHandler();

  const activeTimer$ = buildActiveTimer$(state$, props$);

  startTimer$
    .withLatestFrom(props$, activeTimer$)
    .takeUntil(props$.last())
    .subscribe(([e, props, activeTimer]) => {
      const {task, parentName} = props;

      const payload = buildStartTimerPayload(task, parentName, activeTimer);

      if (payload === null) {
        // TODO: raise error
        console.warn('Unable to start timer. Payload is empty');
        return;
      }

      dispatch(startTimer(payload));
    });

  pause$
    .withLatestFrom(activeTimer$)
    .takeUntil(props$.last())
    .subscribe(([e, activeTimer]) => {
      if (!activeTimer) {
        // TODO: raise error
      } else {
        dispatch(pauseTimer({
          id: activeTimer.id,
          requestId: activeTimer.requestId,
          endedAt: new Date().getTime(),
        }));
      }
    });

  stop$
    .withLatestFrom(activeTimer$)
    .takeUntil(props$.last())
    .subscribe(([e, activeTimer]) => {
      if (!activeTimer) {
        // TODO: raise error
      } else {
        dispatch(stopTimer({
          id: activeTimer.id,
          requestId: activeTimer.requestId,
          endedAt: new Date().getTime(),
        }));
      }
    });

  return props$
    .combineLatest(
      activeTimer$,
      (props, activeTimer) => ({
        ...props,
        ...(activeTimer || {}),
        ...getLocationProps(activeTimer),
        showTimer: activeTimer ? true : props.task && canStartTimer(props.task.status),
        displayTime: activeTimer ? !activeTimer.isStopped : false,
        isStopped: activeTimer ? activeTimer.isStopped === true : true,
        isStarted: activeTimer ? isNumber(activeTimer.startedAt) : false,

        onClickStart,
        onClickPause,
        onClickStop,
      })
    );
};

export const TaskInfoTimerContainer = fuse(StreamedComponent)(TaskInfoTimerView);

TaskInfoTimerContainer.propTypes = {
  task: T.object.isRequired,
  parentName: T.string.isRequired,
};

function buildStartTimerPayload(task, parentName, activeTimer) {
  const payload = {
    targetCollection: getCollection(task),
    targetId: getId(task),
    targetName: task.name,
    parentName: parentName,
    startedAt: new Date().getTime(),
  };

  if (activeTimer) {
    if (activeTimer.startedAt) {
      // TODO: raise error

      return null;
    }

    payload.id = activeTimer.id;
    payload.requestId = activeTimer.requestId;
  } else {
    payload.requestId = queueIdGenerator();
  }

  return payload;
}

/**
 * @param {Observable} state$
 * @param {Observable} props$
 * @return {Observable<TaskInfoTimerProps>}
 */
function buildActiveTimer$(state$, props$) {
  return props$
    .map(props => props.task)
    .distinctUntilChanged(null, getId)
    .switchMap(task => {
      const targetCollection = getCollection(task);
      const targetId = getId(task);

      if (!targetId) {
        return Observable.of(null);
      }

      return state$
        .map(state => getActiveTimers(state).list)
        .distinctUntilChanged()
        .map(findByTarget(targetCollection, targetId))
        .distinctUntilChanged();
    })
    .takeUntil(props$.last())
    .share();
}

// TODO(i18n): Use message codes somewhere in here. maybe return objects and detect string vs object in the View
function getLocationProps(activeTimer) {
  if (activeTimer) {
    const isGpsSupported = gpsSupported();
    let locationText = activeTimer.locCap ? renderLocationText(activeTimer.loc, activeTimer.geo) : '(Not Captured)';
    if (locationText === '')
      locationText = isGpsSupported ? '(Not Captured)' : '(Not Supported)';

    return {
      displayLoc: !activeTimer.isStopped && isGpsSupported,
      location: locationText,
    };
  } else {
    return {
      displayLoc: false,
      location: '',
    };
  }
}



// WEBPACK FOOTER //
// ./src/js/timers/components/TaskInfoTimer/TaskInfoTimerContainer.js